import React from 'react'
import { Modal } from 'antd';
import { StyledModalTitle } from './style'
import moment from 'moment'
import ReactMarkdown from 'react-markdown'

const CalendarModal = ({ visible, item , hideCalendarModal }) =>  {

    if (!item || !visible) {
      return
    }

    const title = (
      <StyledModalTitle>
        <div className="date">
          <span>{item.calendarenddate && moment(item.calendarenddate).format('ddd')}</span>
          <b>{item.calendarenddate && moment(item.calendarenddate).format('D')}</b>
          <span>{item.calendarenddate && moment(item.calendarenddate).format('MMM')}</span>
        </div>
        <div className="title">
          {item.title || ''}
        </div>
      </StyledModalTitle>
    )

    return (
      <Modal
        visible={visible}
        title={title}
        footer={null}
        backdrop={false}
        onCancel={hideCalendarModal}>
        <ReactMarkdown source={item.description || ''}/>
      </Modal>
    );
  }


export default CalendarModal


// WEBPACK FOOTER //
// ./src/components/view-calendar/calendarModal.js